import React from "react";
import { useNavigate } from "./utils/localizedNav";
import { useTranslation } from "react-i18next";
import { fonts, colors } from "./designTokens";
import SEO from "./SEO";

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("notFound.title")} noindex={true} />
      <div
        style={{
          maxWidth: 480,
          margin: "80px auto 60px",
          textAlign: "center",
          fontFamily: fonts.body,
          padding: "0 24px",
        }}
      >
        <div style={{ fontSize: 72, marginBottom: 16, lineHeight: 1 }}>💨</div>
        <h1
          style={{
            fontFamily: fonts.heading,
            color: colors.textDark,
            fontSize: 36,
            marginBottom: 12,
            letterSpacing: 1,
          }}
        >
          {t("notFound.title")}
        </h1>
        <p
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: colors.textDark,
            marginBottom: 8,
          }}
        >
          {t("notFound.heading")}
        </p>
        <p
          style={{
            fontSize: 14,
            color: colors.textMuted,
            marginBottom: 32,
            lineHeight: 1.6,
          }}
        >
          {t("notFound.body")}
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => navigate("/")}
            style={{
              border: "none",
              borderRadius: 999,
              padding: "10px 28px",
              background: colors.btnGreen,
              cursor: "pointer",
              fontSize: 15,
              fontWeight: 700,
              fontFamily: fonts.body,
              color: "#123a1a",
            }}
          >
            {t("notFound.home")}
          </button>
          <button
            onClick={() => navigate("/gallery")}
            style={{
              border: `1.5px solid ${colors.borderLight}`,
              borderRadius: 999,
              padding: "10px 28px",
              background: "transparent",
              cursor: "pointer",
              fontSize: 15,
              fontWeight: 700,
              fontFamily: fonts.body,
              color: colors.textDark,
            }}
          >
            {t("notFound.gallery")}
          </button>
        </div>
      </div>
    </>
  );
}
